<!-- Menu Horizontal Component -->
<div class="" [class.no-scroll]="disableScroll" (scroll)="onScroll($event)" (click)="debugComponentState()">
  <!-- Mobile Header: Hamburger + Isotipo -->
  @if (isMobile) {
    <div class="mobile-top-bar">
      <button class="mobile-hamburger" (click)="toggleMobileMenu($event)"
        [class.active]="isMobileMenuOpen" aria-label="Toggle mobile menu">
        <div class="hamburger-lines">
          <span class="line"></span>
          <span class="line"></span>
          <span class="line"></span>
        </div>
      </button>
      @if (logoIsotipoUrl) {
        <img
          [src]="logoIsotipoUrl"
          [alt]="empresaBranding?.titulo || 'Logo'"
          class="mobile-isotipo"
          (click)="redirectToHome()" />
      }
    </div>
  }

  <!-- Mobile Shadow Line -->
  @if (isMobile) {
    <div class="mobile-shadow-line"></div>
  }

  <!-- Desktop Menu -->
  @if (!isMobile) {
    <div class="menu-container">
      <nav class="menu-nav" #menuNav>
        <ul class="menu-list">
          @if (isLoadingMenu && menuItems.length === 0) {
            @for (_ of skeletonItems; track _; let i = $index) {
              <li class="menu-item menu-item-skeleton">
                <span class="skeleton-pill" [style.width.px]="60 + (i % 4) * 25" aria-hidden="true"></span>
              </li>
            }
          } @else {
            @for (item of menuItems; track item; let i = $index) {
              <li class="menu-item"
                [class.menu-item-active]="hoveredItem === i && isSubmenuActive"
                (mouseenter)="onMenuItemHover(i, $event)" (mouseleave)="onMenuItemLeave()">
                <a [href]="item.redirect || '#'" class="menu-link" (click)="onMenuItemClick(item, $event)">
                  {{ item.label }}
                </a>
              </li>
            }
          }
        </ul>
      </nav>
      <!-- Left Arrow (Desktop only) -->
      @if (showLeftArrow) {
        <button class="nav-arrow arrow-left" (click)="scrollLeft()"
          [disabled]="!canScrollLeft" [style.top.px]="leftArrowPosition.top" [style.left.px]="leftArrowPosition.left">
          <div class="arrow-icon"></div>
        </button>
      }
      <!-- Right Arrow (Desktop only) -->
      @if (showRightArrow) {
        <button class="nav-arrow arrow-right" (click)="scrollRight()"
          [disabled]="!canScrollRight" [style.top.px]="rightArrowPosition.top"
          [style.right.px]="rightArrowPosition.right">
          <div class="arrow-icon"></div>
        </button>
      }
    </div>
  }

  <!-- Mobile Menu Overlay -->
  @if (isMobile && isMobileMenuOpen) {
    <div class="mobile-menu-overlay" (click)="closeMobileMenu()"></div>
  }

  <!-- Mobile Menu -->
  @if (isMobile && isMobileMenuOpen) {
    <nav class="mobile-menu open">
      <!-- Mobile Menu Header -->
      <div class="mobile-menu-header">
        @if (logoPlataformaUrl) {
          <img
            [src]="logoPlataformaUrl"
            [alt]="empresaBranding?.titulo || 'Logo'"
            class="mobile-menu-logo" />
        }
        @if (!logoPlataformaUrl) {
          <h2 class="mobile-menu-title">Navegación</h2>
        }
        <button class="mobile-menu-close" (click)="closeMobileMenu()" aria-label="Cerrar menú">
          <span class="close-icon">✕</span>
        </button>
      </div>
      <ul class="mobile-menu-list">
        @if (isLoadingMenu && menuItems.length === 0) {
          @for (_ of skeletonItems; track _) {
            <li class="mobile-menu-item mobile-menu-item-skeleton">
              <span class="skeleton-bar" aria-hidden="true"></span>
            </li>
          }
        } @else {
          @for (item of menuItems; track item; let i = $index) {
            <li class="mobile-menu-item"
              [class.mobile-menu-item--expanded]="mobileExpandedParentIndex === i"
              [class.parent-highlighted]="mobileExpandedParentIndex === i"
              (click)="onMobileMenuItemClick(item)">
              <a [href]="item.redirect || '#'" class="mobile-menu-link"
                [attr.aria-expanded]="item.subMenu?.length ? (mobileExpandedParentIndex === i) : null"
                (click)="onMobileMenuLinkClick(item, $event, i)">
                {{ item.label }}
              </a>
              <!-- Mobile Submenu -->
              @if (item.subMenu && item.subMenu.length > 0) {
                <ul class="mobile-submenu" (click)="$event.stopPropagation()">
                  @for (subItem of item.subMenu; track subItem; let j = $index) {
                    <li class="mobile-submenu-item"
                      [class.mobile-submenu-item--expanded]="mobileExpandedParentIndex === i && mobileExpandedSubParentIndex === j"
                      [class.parent-highlighted]="mobileExpandedParentIndex === i && mobileExpandedSubParentIndex === j">
                      <a [href]="subItem.redirect || '#'" class="mobile-submenu-link"
                        [class.mobile-submenu-link--has-nested]="!!(subItem.children && subItem.children.length > 0)"
                        [attr.aria-expanded]="subItem.children?.length ? (mobileExpandedParentIndex === i && mobileExpandedSubParentIndex === j) : null"
                        (click)="onMobileSubmenuItemClick(subItem, $event, i, j)">
                        {{ subItem.label }} 
                      </a>
                      <!-- Mobile Nested submenu (level 2) -->
                      @if (subItem.children && subItem.children.length > 0) {
                        <ul class="mobile-nested-submenu"
                          (click)="$event.stopPropagation()">
                          @for (nestedItem of subItem.children; track nestedItem) {
                            <li class="mobile-nested-submenu-item">
                              <a [href]="nestedItem.redirect || '#'" class="mobile-nested-submenu-link"
                                (click)="onMobileNestedSubmenuItemClick(nestedItem, $event)">
                                {{ nestedItem.label }}
                              </a>
                            </li>
                          }
                        </ul>
                      }
                    </li>
                  }
                </ul>
              }
            </li>
          }
        }
      </ul>
    </nav>
  }

  <!-- Desktop submenus: portados a document.body (Safari + overflow del .menu-container) -->
  <div #submenuPortal class="menu-asteric-submenu-portal" aria-hidden="true">
    @if (!isMobile && hoveredItem !== null && menuItems[hoveredItem]?.subMenu?.length) {
      <div
        class="submenu"
        [style.top.px]="submenuPosition.top"
        [style.left.px]="submenuPosition.left"
        (mouseenter)="onSubmenuEnter()"
        (mouseleave)="onSubmenuLeave()">
        <ul class="submenu-list">
          @for (subItem of menuItems[hoveredItem]!.subMenu; track subItem; let j = $index) {
            <li class="submenu-item"
              [class.submenu-item-active]="hoveredSubItem === j && isNestedSubmenuActive"
              [class.has-nested-submenu]="!!(subItem.children && subItem.children.length > 0)"
              (mouseenter)="onSubItemHover(j, $event)"
              (mouseleave)="onSubItemLeave()">
              <a [href]="subItem.redirect || '#'" class="submenu-link"
                (click)="onSubmenuItemClick(subItem, $event)">
                {{ subItem.label }}
              </a>
            </li>
          }
        </ul>
        @if (hoveredSubItem !== null
          && menuItems[hoveredItem]!.subMenu![hoveredSubItem]?.children?.length) {
          <div class="nested-submenu"
            [style.top.px]="nestedSubmenuPosition.top"
            [style.left.px]="nestedSubmenuPosition.left"
            [style.max-height.px]="nestedSubmenuMaxHeight"
            (mouseenter)="onNestedSubmenuEnter()"
            (mouseleave)="onNestedSubmenuLeave()">
            <ul class="nested-submenu-list">
              @for (nestedItem of menuItems[hoveredItem]!.subMenu![hoveredSubItem]!.children; track nestedItem) {
                <li
                  class="nested-submenu-item"
                  (mouseenter)="onNestedItemHover()"
                  (mouseleave)="onNestedItemLeave()">
                  <a [href]="nestedItem.redirect || '#'" class="nested-submenu-link"
                    (click)="onNestedSubmenuItemClick(nestedItem, $event)">
                    {{ nestedItem.label }}
                  </a>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    }
  </div>
</div>